export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "pageTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer Sign In"])}
      },
      "de": {
        "pageTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundenanmeldung"])}
      }
    }
  })
}